import { css } from '@emotion/core';
import theme from '../../themes/default';

const list = css`
  padding: ${theme.spacing.medium};
`;

const compactList = css`
  padding: 0;
`;

export default {
  list: {
    base: list,
    compact: compactList,
  },
};
